import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'
import { redirectToErrorPage } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_DIRECT_PAY = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'PAYMENTS_DIRECT_PAY')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  const token = data.ft
  var verifyFlag // confirmPayInfo接口没有返回数据，没有作为流程推进的判定依据，所以添加这个标记作为推进verify的标记
  if (!token) {
    return redirectToErrorPage({
      code: 400,
      msg: 'Token cannot be empty',
    })
  }
  return (dispatch) => {
    dispatch(loadPayMethod({ token }))
      .then((res) => {
        const payMethodShortNo = _.get(res, 'payload.paymentMethodList[0].payMethodShortNo')
        console.log('payMethodShortNo', payMethodShortNo)
        if (!payMethodShortNo) {
          return false
        }
        verifyFlag = true
        return dispatch(confirmPayInfo({ token, payMethodShortNo }))
      })
      .then((res) => {
        if (!verifyFlag) {
          return false
        }
        return dispatch(verify({ token, authTypeInfoList: [] }))
      })
      .then((res) => {
        const bankFormUrl = _.get(res, 'payload.bankFormUrl')
        console.log(bankFormUrl)
        if (!verifyFlag || !bankFormUrl) {
          return false
        }
        window.location.replace(bankFormUrl)
      })
  }
}

export function loadPayMethod(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/loadPayMethod',
        requestAction: PAYMENTS_DIRECT_PAY.INIT_REQUEST,
        successAction: PAYMENTS_DIRECT_PAY.INIT_SUCCESS,
        success: function(result) {},
        error: function(result) {
          redirectToErrorPage(result.head)
        },
      })
    )
  }
}

export function confirmPayInfo(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          ...data,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          userAgent: navigator.userAgent,
        },
        endpoint: 'cgs/cashdesk/confirmPayInfo',
        requestAction: PAYMENTS_DIRECT_PAY.INIT_REQUEST,
        successAction: PAYMENTS_DIRECT_PAY.INIT_SUCCESS,
        success: function(result) {},
        error: function(result) {
          redirectToErrorPage(result.head)
        },
      })
    )
  }
}

export function verify(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/verify',
        requestAction: PAYMENTS_DIRECT_PAY.INIT_REQUEST,
        successAction: PAYMENTS_DIRECT_PAY.INIT_SUCCESS,
        success: function(result) {},
        error: function(result) {
          redirectToErrorPage(result.head)
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_DIRECT_PAY.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_DIRECT_PAY.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsDirectPay',
    reducerMap: {
      paymentsDirectPayState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
